import posthog from 'posthog-js'

// reportCrash logs a React render crash and forwards it to PostHog error
// tracking (already initialised by PostHogProvider in main.tsx). posthog-js
// is a no-op when it was never initialised, so this is safe in tests and dev.
export function reportCrash(error: unknown): void {
  console.error('Page crashed:', error)
  try {
    posthog.captureException(error)
  } catch {
    // Reporting must never throw out of an error boundary.
  }
}
